import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import * as translations from "@app/locales/en/translation.json";
import * as traduceri from "@app/locales/ro/translation.json";
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: translations,
      },
      ro: {
        translation: traduceri,
      },
    },
    lng: "ro",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
